var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2975 20.0385L16.0614 14.5928C17.4077 12.9924 18.1454 10.9788 18.1454 8.88249C18.1454 3.98476 14.1606 0 9.26286 0C4.36513 0 0.380371 3.98476 0.380371 8.88249C0.380371 13.7802 4.36513 17.765 9.26286 17.765C11.1015 17.765 12.8537 17.2104 14.3518 16.1576L19.6276 21.6447C19.8481 21.8737 20.1447 22 20.4625 22C20.7634 22 21.0488 21.8853 21.2654 21.6768C21.7258 21.2338 21.7404 20.4992 21.2975 20.0385ZM9.26286 2.31717C12.8831 2.31717 15.8282 5.2623 15.8282 8.88249C15.8282 12.5027 12.8831 15.4478 9.26286 15.4478C5.64267 15.4478 2.69754 12.5027 2.69754 8.88249C2.69754 5.2623 5.64267 2.31717 9.26286 2.31717Z",
    fill: "#8E8D8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon_search.13f09081d1719eebfb6d8ffc0b84795e.svg";
export { ForwardRef as ReactComponent };